<script>
	// #ifdef MP
	     import wx_event from '/common/utils/wx_event.js'
	// #endif
	export default {
		onLaunch: function() {
			//获取是否新
			// #ifdef MP
			wx_event.updateApp()
			wx_event.showShareMenu()
			// #endif
		},
		onShow: function() {
		},
		onHide: function() {
			console.log('App Hide')
		},
		onPageNotFound: function() {
			console.log('onPageNotFound')
		},
		methods: {
			// updateUserInfo() {
			// 	uni.$u.http.post('/user/getUserInfo', {}).then((res) => {
			// 		console.log('userInfo:::', JSON.stringify(res.data, null, 2))
			// 		uni.$store('data').setUserInfo(res.data)
			// 	})
			// }
		}
	}
</script>

<style lang="scss">
	@import "@/common/base/index.scss";
	@import "@/uni_modules/uview-plus/index.scss";
</style>